<template>
  <Modal v-model="model" :title="title" sticky reset-drag-position @on-cancel="cancel" footer-hide scrollable :mask="false" draggable class="view_know_pop insert_edit_pop" width="800">
    <div class="form-div main-margin-div">
      <div class="title" style="text-align: center">
        <h1>{{tittle}}</h1>
        <span><a v-if="remark!='0'" href="javascript:void(0);" class="el-icon-shopping-cart-2" @click="changeLove">&nbsp;{{isCollect=='1'?'已收藏':'收藏'}}</a></span>
      </div>
      <div id="content" class="content_div">
          <p v-html="content"></p>
      </div>
      <div class="file_list_div">
        <div class="files" style="padding-top: 20px;" v-for="(item , index) in uploadList" :key="index" :id="item.id">
          <a :href="item.fileUrl" target="_blank">{{item.showName}}</a>
          <p style="padding-top: 10px;">{{item.description}}</p>
        </div>
      </div>
    </div>
  </Modal>
</template>

<script>
  import {publicFunClass} from '@/components/js/PublicFunClass.js'
  export default {
    name: "ViewknowContentPop",
    mixins:[publicFunClass],
    props: {
      openDataKnlgPop:Boolean,
      contentId:String,
    },
    data(){
      return {
        uploadList:[],
        fileUrl:'',
        downName:'',
        isCollect:'',
        isOpen:'',
        tittle:'',
        fileAddr:'',
        description:'',
        title:'查看知识库内容',
        content:'',
        model:false,
        spinShow:true,
        selected:true,
        showMessage:false,
        modelHeight:{'maxHeight':'','marginTop':'20px'},
        configInfo: JSON.parse(localStorage.getItem("configInfo")),
        remark:'',
      }
    },
    methods:{
      cancel:function(){
        this.$emit("closeknowContentPop",false);
      },
      changeLove:function(){
        let that=this;
        let journalType="知识库内容收藏";
        if("0"==this.isCollect){
          this.isCollect="1";
        }else{
          this.isCollect="0";
          journalType="知识库内容取消收藏";
        }
        let param={
          id:this.contentId,
          type:this.isCollect,
          journalType:journalType,
          menuId:"null"
        };
        this.$http.post("knowledge/doCollectors.json",param) .then(function (res) {
          let result = res.data.flag;
          if (result != "666") {
            that.$Modal.info({
              title: '提示',
              content: res.data.msg
            });
            return false;
          }
        });
      },
      initSearch:function (contentId) {
        let that=this;
        let param={
          id:contentId,
          journalType:"null",
          menuId:"null"
        };
        this.$http.post("knowledge/selectOne.json",param) .then(function (res) {
          let result=res.data.flag;
          if(result!="666"){
            that.$Modal.info({
              title:'提示',
              content:res.data.msg
            });
            return false;
          }
          let addressList = res.data.obj.fileAddrs;
          if(addressList!=null){
            for (let i=0;i<addressList.length;i++){
              let param={
                showName:addressList[i].showName,
                fileUrl:that.baseURL+"common/downloadFile.json?type=0&addr="+addressList[i].downName,
                description:addressList[i].description,
              }
              that.uploadList.push(param);
            }
          }
          let list=res.data.obj;
          that.tittle=list.tittle;
          that.keyWord=list.keyWord;
          that.content=list.content;
          that.remark=list.remark;
          that.isCollect=list.collect;
        });
      },
    },
    watch:{
      openDataKnlgPop:function () {
        this.model=this.openDataKnlgPop;
        this.initSearch(this.contentId+"");
        this.downName="";
        this.fileUrl="";
        this.tittle="";
        this.keyWord="";
        this.content="";
        this.remark="";
        this.isCollect="";
        this.description="";
        this.uploadList=[];
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/knowledgeBase/ViewknowContentPop.vue